import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ApontamentoTemp from "./views/Apontamentos/ApontamentosTemp";
import Apontamento from "./views/Apontamentos/Apontamentos";
import ResumoHorasMes from "./views/ResumoHorasMes";
import LinkPendency from './views/LinkPendency';
import SaldoHoras from './views/SaldoHoras';


export default () => {
  return (
      <Switch>
          <Route path="/apontamentos" exact component={Apontamento}/>
          <Route path="/resumo" exact component={ResumoHorasMes}/>
          <Route path={'/link-apontamento'} component={LinkPendency}/>
          <Route path={'/saldo'} component={SaldoHoras}/>
          <Route component={ResumoHorasMes}/>
      </Switch>
    )
}
